import { NotificationType } from '@routific/hive';
import i18n from '../../i18n';

const PENDING_INVITE_RECEIVED_TOAST_KEY = 'pending-invite-received';

export const pendingInviteReceivedNotification = (count: number, onAccountSettingsClick: () => void) => ({
  id: `${PENDING_INVITE_RECEIVED_TOAST_KEY}-${Date.now()}`,
  type: NotificationType.INFO,
  message: i18n.t('notifications:pendingInvites.message', { count }),
  priority: true,
  dataCy: 'pending-invite-received-notification',
  linkMessage: i18n.t('notifications:pendingInvites.accountSettings'),
  linkOnClick: onAccountSettingsClick,
});

